class ConnectionStatusController {
    constructor(UserConnectionServiceApi) {
        this.connectionStatuses = [];
        this.anyConnection = false;
        this.isUpdating = false;
        this.$onInit = () => {
            this.connectionStatusController = this;
            this.update();
        };
        this.UserConnectionServiceApi = UserConnectionServiceApi;
    }
    update() {
        this.isUpdating = true;
        this.connectionStatuses = [];
        this.UserConnectionServiceApi
            .getConnectionStatus(this.simulatorId, this.userId)
            .then((response) => {
            if (response.status !== 200) {
                return;
            }
            let latestConnectionStatuses = response.data.AllConnectionStatus;
            if (latestConnectionStatuses === undefined) {
                return;
            }
            this.connectionStatuses = latestConnectionStatuses;
        })
            .finally(() => {
            this.anyConnection = this.connectionStatuses.length > 0;
            this.isUpdating = false;
        });
    }
    getConnectionStatusText(connection) {
        let result = connection.Name + ': ' + connection.Status;
        let errors = connection.Errors;
        if (errors !== undefined && errors.length > 0) {
            result += `\nError${errors.length === 1 ? '' : 's'}:`;
            errors.forEach(error => {
                result += '\n- ' + error;
            });
        }
        return result;
    }
    getButtonClass(connectionStatus) {
        switch (connectionStatus) {
            case 'Connected':
                return 'btn btn-connected';
            default:
                return 'btn btn-not-connected';
        }
    }
}
angular.module('app').component('connectionStatus', {
    bindings: {
        userId: '<',
        simulatorId: '<',
        connectionStatusController: '='
    },
    controllerAs: 'vm',
    controller: ConnectionStatusController,
    templateUrl: 'scripts/app/partials/TestExecution/ConnectionStatus/connection-status.tpl.html'
});
